import moment from 'moment';
import { getScanDate, getData } from '@/components/report/service';
import GenerateCondit from '@/models/GenerateCondit';
import RouteEntity from '@/Entity/RouteEntity';
import { getDeliveryReceiptMessage } from '@/services/api';
import {
  CALCWEIGHT,
  GOODSVOLUME,
  GOODSWEIGHT,
  PIECE,
  TICKET,
  SKETCHTICKET,
} from '@/models/GenerateCondit/Interrelated';

const paramsForm = {
  carNo: '',
  orderType: 'deliveryReceiptNo',
  thisStation: '分拨装车',
  thisSiteObj: '',
  billOrSignDate: 'billDate',
  startDate: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
  endDate: moment(new Date()).format('YYYY-MM-DD 12:00:00'),
};

export default {
  namespace: 'handoverOrderManagement',
  state: {
    searchParams: { ...paramsForm },
    dataList: [],
    page: 1,
    pageSize: 20,
    detailList: [],
    detailPage: 1,
    detailPageSize: 40,
    handoverShow: false,
    rowkeys: [],
    newArr: [],
  },
  effects: {
    *getTableDate({ payload }, { call, put, select }) {
      const {
        page,
        pageSize,
        dataList,
        searchParams: { startDate, endDate, carNo, ewbNoList, thisStation, orderType },
      } = yield select(({ handoverOrderManagement }) => handoverOrderManagement);
      const pages = payload?.page || page;
      const offset = pageSize * (pages - 1) || null;
      const dimList =
        thisStation === '分拨装车'
          ? ['deliveryReceiptNo', 'taskNo', 'scanSite', 'nextSite', 'carNo', 'carType']
          : ['deliveryReceiptNo', 'taskNo', 'preSite', 'scanSite', 'carNo', 'carType'];
      const gc = new GenerateCondit({
        dataSource: 'actual_load_unload_result',
        dimensions: dimList,
        aggregators: [CALCWEIGHT, GOODSVOLUME, GOODSWEIGHT, PIECE, TICKET, SKETCHTICKET],
        limit: pageSize,
        startDate: startDate,
        endDate: endDate,
        queryType: 'groupBy',
        offset: offset,
      });
      const entity = new RouteEntity({
        scanSite: '',
        scanType: thisStation,
        [orderType]: ewbNoList,
        carNo: carNo,
        isDestinationCenter: '否',
      });
      const condit = gc.converCondit(entity);
      const dataTime = yield getData(condit);
      const tempData = dataTime?.map((m, index) => ({
        ids: index + offset,
        ...m,
      }));
      let result = dataList;
      if (pages === 1) {
        result = [];
      }
      Array.prototype.push.apply(result, tempData);
      yield put({
        type: 'update',
        payload: {
          dataList: [].concat(result),
          page: pages,
        },
      });
    },

    *getDruid(_, { call, put, select }) {
      const {
        rowkeys,
        searchParams: { startDate, endDate },
      } = yield select(({ handoverOrderManagement }) => handoverOrderManagement);
      const gc = new GenerateCondit({
        dataSource: 'actual_load_unload_result',
        dimensions: [
          'waybillNo', //主单号
          'subBillNo',
          'piece',
          'calcWeight',
          'goodsVolume',
          'productType',
        ],
        aggregators: [],
        startDate: startDate,
        endDate: endDate,
        queryType: 'scan',
      });
      const entity = new RouteEntity({ deliveryReceiptNo: rowkeys });
      const condit = gc.converCondit(entity);
      const delList = yield getScanDate(condit, 'druid');
      yield put({
        type: 'update',
        payload: {
          detailList: delList,
        },
      });
    },

    *getDeliveryReceiptMessage(_, { put, select }) {
      const { rowkeys } = yield select(({ handoverOrderManagement }) => handoverOrderManagement);
      const datas = {
        tableName: 'actual_delivery_receipt_result',
        namespace: 'route_rs',
        rowkeys: rowkeys,
      };
      const delList = yield getDeliveryReceiptMessage({ ...datas });
      const parseData = JSON.parse(delList.data);
      const waybillNo = 'waybillNo';
      const newArr = parseData.reduce(
        (all, next) =>
          all.some(item => item[waybillNo] == next[waybillNo]) ? all : [...all, next],
        [],
      );
      yield put({
        type: 'update',
        payload: {
          detailList: parseData,
          newArr: newArr,
        },
      });
    },

    // 点击按钮清除搜索表单
    *searchClean(_, { put }) {
      yield put({ type: 'update', payload: { searchParams: { ...paramsForm } } });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
